import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ProductPicker } from "@/components/products/ProductPicker";
import { api } from "@/lib/api";

const CUSTOM = "__custom__";

export const ReportProducts = ({ value, onChange }) => {
  const v = value || {};
  const [lists, setLists] = useState([]);
  useEffect(() => { api.get("/products/lists").then((r) => setLists(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-2 rounded-lg border border-slate-100 p-3" data-testid="report-products">
      <Select value={v.list_id || CUSTOM} onValueChange={(id) => onChange(id === CUSTOM ? { list_id: "", items: v.items || [] } : { list_id: id, items: [] })}>
        <SelectTrigger data-testid="report-products-list"><SelectValue /></SelectTrigger>
        <SelectContent><SelectItem value={CUSTOM}>Prodotti scelti qui</SelectItem>{lists.map((l) => <SelectItem key={l.id} value={l.id}>Lista: {l.name} ({l.items.length})</SelectItem>)}</SelectContent>
      </Select>
      {!v.list_id && <ProductPicker value={v.items || []} onChange={(items) => onChange({ list_id: "", items })} />}
      <p className="text-[11px] text-slate-400">Il periodo è quello del report (o gli ultimi 30 giorni), confrontato con il periodo precedente. Una lista salvata si aggiorna in tutti i report che la usano.</p>
    </div>
  );
};
